import { render, staticRenderFns } from "./InvoiceDeliveryNotice.vue?vue&type=template&id=575d63dd&scoped=true&"
import script from "./InvoiceDeliveryNotice.vue?vue&type=script&lang=js&"
export * from "./InvoiceDeliveryNotice.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDeliveryNotice.vue?vue&type=style&index=0&id=575d63dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575d63dd",
  null
  
)

export default component.exports